import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Carlos Silva",
    role: "Empresário",
    content: "Comecei a copiar as operações há 6 meses e os resultados superaram minhas expectativas. A equipe é extremamente profissional e transparente.",
    rating: 5,
    image: "/lovable-uploads/76c1b706-8055-4df1-82c9-b54239cf3632.png"
  },
  {
    name: "Marina Costa",
    role: "Investidora",
    content: "O processo é simples e seguro. A plataforma funciona perfeitamente e consigo acompanhar todas as operações em tempo real. Recomendo!",
    rating: 5,
    image: "/lovable-uploads/a9f58a86-15ae-4240-8c12-7df6788eddd2.png"
  },
  {
    name: "Roberto Almeida",
    role: "Médico",
    content: "Estava buscando uma forma de investir sem precisar dedicar muito tempo. Com a Karpa Investimentos encontrei a solução perfeita. Excelente serviço!",
    rating: 5,
    image: "/lovable-uploads/76c1b706-8055-4df1-82c9-b54239cf3632.png"
  }
];

const TestimonialsSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            <span className="text-foreground">O Que Nossos </span>
            <span className="bg-gradient-primary bg-clip-text text-transparent">Clientes Dizem</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Depoimentos reais de quem já está operando conosco
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-6 shadow-card hover:shadow-elegant transition-all duration-300 border border-border"
            >
              <div className="mb-4">
                <Quote className="w-10 h-10 text-primary/30" />
              </div>
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-primary text-primary" />
                ))}
              </div>

              <p className="text-muted-foreground mb-6 italic">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-primary rounded-full flex items-center justify-center">
                  <span className="text-primary-foreground font-bold text-lg">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
